export function buildItBiweeklyReportParams(statDate?: string) {
  return statDate === undefined ? {} : { statDate }
}
